export function initGoogleMaps() {
    checkGoogleMapConsent()
    document.addEventListener("cookieOverlaySubmitted", checkGoogleMapConsent)

    $(".map-links a.karte").click(() => {
        $("html,body").animate(
            {
                scrollTop: $("#einzelansicht-map").offset().top - $(".anzeigen-list-navigation").height(),
            },
            "slow",
        )

        return false
    })
}

const loadGoogleMap = () => {
    document.getElementById("map")?.classList.remove("placeholder")

    const einzelansichtMap = document.getElementById("einzelansicht-map")
    if (einzelansichtMap) {
        einzelansichtMap.classList.remove("hidden")
        einzelansichtMap.setAttribute("src", einzelansichtMap.dataset.src || "")
    }

    document.getElementById("einzelansicht-map-placeholder")?.classList.add("hidden")
}

function checkGoogleMapConsent() {
    if (window.getCookieOverlayValue("cookie-category-map_services")) {
        loadGoogleMap()
    }
}

window.acceptGoogleMapConsent = () => {
    window.setCookieOverlayValue("cookie-category-map_services", "1")
    loadGoogleMap()
}
